/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable indent */
import React from 'react';
import { Internationalization } from '@syncfusion/ej2-base';
import moment from 'moment';
import {
  ImportMinutageArchitectureAPI,
  GetMinutageArchitectureAPI,
  ExportChannelArchitectureMinutageAPI,
} from 'api';
import { formatDateWithMoment } from 'utils';
import { ImportComponent } from './modals/ImportComponent';
import Button from 'shared/components/button/Button';
import { padStart } from '@fullcalendar/react';
import ModifyGradingAndMinutage from './modals/ModifyGradingAndMinutage';
import useStore from 'store/AccountStore';
import { OpScheduler } from 'op2mise-react-widgets';
import './ChannelArchitecture.css';

export function CAMinutage({
  schedulerProps,
  channelInfo,
  handleGetEventDate,
  startDate,
  endDate,
  isDirty,
  setIsDirty,
  setMinutage,
  handleSaveMinutageArchitecture,
  handleConstructGridData,
}) {
  const { user } = useStore((state) => state);
  const instance = new Internationalization();
  const [schedules, setSchedules] = React.useState([{}]);
  const [openForm, setOpenForm] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(false);
  const [refreshSchedules, setRefreshSchedules] = React.useState(false);
  const { channelId, channelName } = channelInfo;
  const blockData = React.useRef({});
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const tomorrow = moment()
    .add(1, 'days')
    .toDate();

  const period = `${formatDateWithMoment(
    new Date().toDateString()
  )} - ${formatDateWithMoment(tomorrow)}`;

  // Date Header Template
  const dateHeaderTemplate = (args) => {
    const day = instance.formatDate(args.date, { skeleton: 'E' });
    return (
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div
          className="e-header-day"
          style={{ flex: 1, display: 'flex', justifyContent: 'center' }}
        >
          {day}
        </div>
      </div>
    );
  };

  const eventFields = (args) => ({
    Minutage: args.minutage,
    Id: args.id,
    Subject: args.minutage,
    ProgramType: args.programType,
    StartTime: handleGetEventDate(args, 'startTime'),
    EndTime: handleGetEventDate(args, 'endTime'),
  });

  const eventTemplate = (args) => {
    const { Minutage } = args;
    return (
      <React.Fragment>
        <div className="op-event-subject">
          <div className="e-ca-grading-subject">
            <div className="e-schedule-custom-event-title e-schedule-minutage-title">
              {Minutage.toFixed(2)}
            </div>
          </div>
        </div>
        <div className="op-event-content">{null}</div>
      </React.Fragment>
    );
  };

  const tooltipTemplate = (args) => {
    return (
      <div className="tooltip-wrap">
        <div className="content-area">
          <div className="event-name">
            <span>{args.Minutage.toFixed(2)}</span>
          </div>
        </div>
      </div>
    );
  };

  const customFooter = React.useCallback(
    ({ events, schedulerActions }) => {
      return (
        <div style={{ marginTop: '15px', float: 'right' }}>
          <Button
            text="Save"
            style={{ marginLeft: '10px' }}
            onClick={() => {
              handleSaveMinutageArchitecture(schedulerActions.EventGetAll());
              schedulerActions.ResetEventHistory();
              setRefreshSchedules(true);
            }}
            disabled={!isDirty}
          />
        </div>
      );
    },
    [isDirty]
  );

  const handleOnExport = () => {
    if (schedules.minutage.length) {
      ExportChannelArchitectureMinutageAPI({
        queryParams: { channelId },
        onSuccess: (res) => {
          const { organisationName } = user;
          let exportDate = new Date();
          const exportedDateString =
            padStart(exportDate.getDate(), 2).toString() +
            padStart(exportDate.getMonth() + 1, 2).toString() +
            exportDate.getFullYear().toString();
          const fileName = `${organisationName}_op2mise_channel_architecture_minutage_export_${channelName}_${exportedDateString}.xlsx`;
          const blob = new Blob([res], {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          saveAs(blob, fileName);
        },
      });
    }
  };

  const handleOnImport = (args) => {
    blockData.current = {
      ...args.data,
      EventGetAll: args.schedulerActions.EventGetAll,
      ResetEventHistory: args.schedulerActions.ResetEventHistory,
      EventRecord: args.schedulerActions.EventRecord,
    };
    // Put your import logic here
    setOpenForm('IMPORT');
  };

  const handleOnSlotModified = (args) => {
    setIsDialogOpen(true);
    blockData.current = {
      ...args.data,
      ProgramType: undefined,
      EventGetAll: args.schedulerActions.EventGetAll,
      EventChange: args.schedulerActions.EventChange,
      ResetEventHistory: args.schedulerActions.ResetEventHistory,
    };
  };

  const handleMinutageUpdate = (newMinutage) => {
    blockData.current.EventChange({
      ...blockData.current,
      Minutage: newMinutage,
    });

    const allEvents = blockData.current.EventGetAll();
    setMinutage(allEvents);
    setIsDirty(true);
  };

  const modifyMinutageProps = {
    isOpen: isDialogOpen,
    closeModal: () => {
      setIsDialogOpen(false);
    },
    handleUpdate: handleMinutageUpdate,
    blockData: blockData.current,
    type: 'minutage',
  };

  const cleanOutInvalidMinutage = (data) => {
    return data.filter((schedule) => schedule.minutage);
  };

  React.useEffect(() => {
    setIsDialogOpen(false);
    blockData.current = {};
  }, []);

  React.useEffect(() => {
    if (channelId || refreshSchedules) {
      GetMinutageArchitectureAPI({
        queryParams: { channelId },
        onSuccess: (response) => {
          const validMinutage = cleanOutInvalidMinutage(response);
          setSchedules({
            minutage: handleConstructGridData(validMinutage, true),
          });
          setRefreshSchedules(false);
        },
        setLoader: setIsLoading,
      });
    }
  }, [channelId]);

  return (
    <>
      {' '}
      {openForm === 'IMPORT' && (
        <ImportComponent
          closeModal={() => setOpenForm('')}
          setIsDirty={setIsDirty}
          setIsLoading={setIsLoading}
          scheduleInfo={{
            ...channelInfo,
            period,
          }}
          schedulerData={{
            schedules: schedules.minutage,
            scheduleInfo: {
              ...channelInfo,
            },
            period,
          }}
          sampleTemplate="minutageImportTemplate"
          handleOnImportApi={ImportMinutageArchitectureAPI}
          dataExists="gradeMinutageArchitectureExist"
          dataModel="gradeMinutageArchitectureModel"
          fileError="gradeMinutageArchitectureError"
          importResultColumns={[
            {
              field: 'dayOfWeek',
              headerText: 'Day of Week',
            },
            {
              field: 'startTime',
              headerText: 'Start Time',
            },
            {
              field: 'endTime',
              headerText: 'End Time',
            },
            {
              field: 'minutage',
              headerText: 'Minutage',
            },
          ]}
          importResultFileTitle="minutage_import_result"
          setSchedules={(data) => {
            if (data.length) {
              const importedData = handleConstructGridData(data, true);
              setSchedules({
                ...schedules,
                minutage: importedData,
              });
              blockData.current.EventRecord(importedData);
              setMinutage(importedData);
              setIsDirty(true);
              setIsLoading(false);
            }
          }}
        />
      )}
      {isDialogOpen && <ModifyGradingAndMinutage {...modifyMinutageProps} />}
      {channelId === 0 && !channelName ? null : (
        <OpScheduler
          {...schedulerProps}
          addButton={false}
          customTooltipTemplate={tooltipTemplate}
          dataSource={schedules}
          eventLookupList={'minutage'}
          loading={isLoading}
          suppressQuickInfo={true}
          suppressTooltip={false}
          dateHeaderTemplate={dateHeaderTemplate}
          eventTemplate={eventTemplate}
          eventFields={eventFields}
          onImport={handleOnImport}
          onExport={handleOnExport}
          onSlotModified={handleOnSlotModified}
          settings={['SLOT DURATION', 'SLOT INTERVAL']}
          schedule={{ start: startDate, end: endDate }}
          timeoutDelay={800}
          actionButtonPanel={(events, schedulerActions) =>
            customFooter(events, schedulerActions)
          }
          heightBuffer={230}
          suppressOverlappingSchedules={true}
        />
      )}
    </>
  );
}

export default CAMinutage;
